import { createHttpClient } from '@opengoal/http';
import { env } from '@/app/env';
import { clearSession, getSessionToken } from '@/lib/session';

/**
 * The single fetch entry point for the admin app.
 *
 * Orval is configured to route every generated endpoint through this function
 * (see orval.config.ts → override.mutator), so auth headers, error
 * normalization, and 401 handling are wired once here rather than per call.
 *
 * Do not call `fetch` directly anywhere else in the app.
 */
export const apiRequest = createHttpClient({
  baseUrl: env.apiBaseUrl,
  getToken: getSessionToken,
  onUnauthorized: () => {
    // The session is gone server-side; keeping the stale token around only
    // produces a cascade of further 401s. Hard-reset and bounce to sign-in.
    clearSession();

    if (!window.location.pathname.startsWith('/login')) {
      const next = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.assign(`/login?next=${next}`);
    }
  },
});
